import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    title: 'Your company creation project',
  },

  fr: {
    title: 'Votre projet de création d’entreprise',
  },
} as const);

export default locales;
